const ROOT_API = process.env.VUE_APP_ROOT_API;
const COMPOSITION_UNITS =
  ROOT_API + "get_site_data/priority_species/composition_units.php";
const PRIMARY_SPECIES =
  ROOT_API + "get_site_data/priority_species/primary_species.php";

export const fetchCompositionUnits = async (lpo_id) => {
  const form = new FormData();
  form.append("lpo_id", lpo_id);

  const response = await fetch(COMPOSITION_UNITS, {
    credentials: "include",
    method: "post",
    body: form,
  });

  const result = await response.json();
  return result;
};

export const fetchPrimarySpecies = async (lpo_id) => {
  const form = new FormData();
  form.append("lpo_id", lpo_id);

  const response = await fetch(PRIMARY_SPECIES, {
    credentials: "include",
    method: "post",
    body: form,
  });

  const result = await response.json();
  return result;
};
